import React, { FunctionComponent } from "react";
import clsx from "clsx";
import styles from "./geolocation-menu-item.module.scss";

export const GEOLOCATION_TO_LABEL: Record<string, string> = {
  us: "United States (us)",
  uk: "United Kingdom (uk)",
  in: "India (in)",
  br: "Brazil (br)",
  de: "Germany (de)",
  jp: "Japan (jp)",
  sg: "Singapore (sg)",
  it: "Italy (it)",
  es: "Spain (es)",
  fr: "France (fr)",
  tor: "TOR (tor)"
};

const GEOLOCATION_TO_IMAGE: Record<string, string> = {
  us: "us",
  uk: "gb-eng",
  in: "in",
  br: "br",
  de: "de",
  jp: "jp",
  sg: "sg",
  it: "it",
  es: "es",
  fr: "fr"
};

type GeolocationMenuItemProps = {
  value?: string;
};

const GeolocationMenuItem: FunctionComponent<GeolocationMenuItemProps> = ({
  value
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className={"d-flex align-items-center"}>
      {GEOLOCATION_TO_IMAGE[value] && (
        <img
          className={clsx("me-5", styles.flag_icon)}
          src={`${window.tcbase.urls.static}flags/${GEOLOCATION_TO_IMAGE[value]}.png`}
        />
      )}
      <span className={"overflow-ellipsis"}>{GEOLOCATION_TO_LABEL[value]}</span>
    </div>
  );
};

export default GeolocationMenuItem;
